<div class="block-schedule__top">
    <ridango-ui-back-button>
        <a [routerLink]="'/schedule/planner' | localize">{{ 'LOCAL_BTN_BACK' | translate }}</a>
    </ridango-ui-back-button>
    <h1 *ngIf="(selectedOrigin$ | async)?.name && (selectedDestination$ | async)?.name">{{(selectedOrigin$ | async)?.name}} <span class="icon icon-arrow-right-link"> </span> {{(selectedDestination$ | async)?.name}}</h1>
    
    <div class="flex padding-10 planner-trips-times">
        <div class="flex1 bold">{{(trips$ | async)[tripId].LegList.Leg[0].Origin.time | timeFromString:'hh:mm'}} <span class="icon icon-arrow-right-link align-self-center"> </span>
            {{(trips$ | async)[tripId].LegList.Leg[trip.LegList.Leg.length-1].Destination.time | timeFromString:'hh:mm'}}</div>
            <div class="planner-trips-times__duration align-self-center">{{(trips$ | async)[tripId].duration | duration}}</div>
    </div>
</div>

<div class="block-schedule__bottom remove-padding"> 
    <ng-container *ngIf="(trips$ | async)?.length > 0 && tripId">
        <ul class="remove-bullets route-list">
            <ng-container *ngFor="let leg of (trips$ | async)[tripId].LegList.Leg; let first = first; let last = last;">            
                <li class="even-odd-color" *ngIf="!(leg.type === 'WALK' && leg.dist === 0)">
                    
                    <div class="flex-center flex1">
                        <span class="padding-10 time-origin">{{leg.Origin.time | timeFromString:'hh:mm'}}</span>

                        <a class="flex-center full-width min-height-50 name-origin"> 
                            <span class="route-list--stop">
                                <!--<span *ngIf="leg.type === 'JNY' && leg.Product && leg.Product.catCode" 
                                    class="{{'transport-type-' + leg.Product.catCode}}"
                                    [ngSwitch]="leg.Product.catCode">   
                                    <span *ngSwitchCase="'1'" class="icon icon-train"></span>
                                    <span *ngSwitchCase="'2'" class="icon icon-train"></span>
                                    <span *ngSwitchCase="'3'" class="icon icon-bus2"></span>
                                    <span *ngSwitchCase="'4'" class="icon icon-train"></span>
                                    <span *ngSwitchCase="'5'" class="icon icon-subway"></span>
                                    <span *ngSwitchCase="'6'" class="icon icon-train"></span>
                                    <span *ngSwitchCase="'7'" class="icon icon-bus"></span>
                                    <span *ngSwitchCase="'8'" class="icon icon-ferry"></span>
                                    <span *ngSwitchCase="'9'" class="icon icon-car"></span>
                                </span>-->
                            </span> 
        
                            <div class="leg-title position-relative min-height-60 padding-10 flex1">
                                <span>{{ (first) ? (selectedOrigin$ | async)?.name : leg.Origin.name }}</span>
                            </div>
                        </a>
                    </div>

                    <div class="flex-center full-width min-height-50" >
                        <div class="time-origin"></div>
                        <div class="flex padding-left-10 transport-type min-height-50 planner-trips-info-items" [ngClass]="{ 'walk-line': leg.type === 'WALK' }">
                            <span class="walk align-self-center" *ngIf="leg.type==='WALK'"><span class="icon icon-walking"></span> {{leg.dist}}m</span> 
                            <span class="line-number align-self-center" *ngIf="leg.type==='JNY'">{{leg.number}}</span>
                            <span class="line-direction flex1 padding-10 align-self-center" *ngIf="leg.type==='JNY'">{{leg.direction}}</span>
                            <span class="flex-center" *ngIf="leg.type==='TRSF'">
                                <span class="flex-center walk">
                                    <span [ngClass]="{'transfer-line': leg.type ==='TRSF' }">Transfer</span>
                                    <span class="icon icon-walking"></span>
                                    <span *ngIf="leg.dist">{{leg.dist}}m</span>
                                    <span *ngIf="leg.dist && leg.duration">, </span>
                                    <span *ngIf="leg.duration">{{leg.duration | duration}}</span>
                                </span>
                            </span>
                        </div>
                    </div>
                </li>

                <li *ngIf="last" class="even-odd-color">
                <div>
                        <a class="leg-title flex-center full-width min-height-50 flex1">
                            <span class="time-destination padding-10">{{leg.Destination.time | timeFromString:'hh:mm'}}</span>
                            <div class="flex-center full-width min-height-50 name-destination">
                                <span class="route-list--stop"></span>
                                <span class="padding-10 flex1">{{(selectedDestination$ | async)?.name}}</span>
                            </div>
                        </a>
                    </div>
                </li>
            </ng-container>            
        </ul>
    </ng-container>
</div>